import { LinkedChainNavigation } from 'components/linkedChainNavigation/linkedChainNavigation'
import { QuestProgress as Component } from 'components/questProgress/component'
import { connect } from 'react-redux'
import { RootState } from 'stores'

const linkedChainNavigation = new LinkedChainNavigation('')

const mapStateToProps = (state: RootState) => {
  linkedChainNavigation.currentPath = state.router.location.pathname

  return {
    index: linkedChainNavigation.currentIndex,
    length: linkedChainNavigation.length
  }
}

export const QuestProgress = connect(mapStateToProps)(Component)
